import { Box, Button, Chip, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material'
import axios from 'axios';
import React from 'react'
import { useTheme } from 'styled-components';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

function getStyles(name, personName) {
  return ;
}

const ConfigureTicket = () => {
    const [age, setAge] = React.useState('');
    const theme = useTheme();
    const [level1, setlevel1] = React.useState([])
    const [level2, setlevel2] = React.useState([])
    const [level3, setlevel3] = React.useState([])
    const [category, setcategory] = React.useState('')
    const [subcategory, setsubcategory] = React.useState('')
    const [errors, setErrors] = React.useState({});

 

      const handleChangeLevel1=(event)=>{
        const {
            target: { value },
          } = event;
          setlevel1(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
          );
      }

      const handleChangeLevel2=(event)=>{
        const {
            target: { value },
          } = event;
          setlevel2(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
          );
      }

      const handleChangeLevel3=(event)=>{
        const {
            target: { value },
          } = event;
          setlevel3(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
          );
      }

  const handleChangeCategory=(event)=>{
    const {
        target: { value },
      } = event;
      setcategory(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value : value,
      );
  }

  const validate = () => {
    let tempErrors = {};
    if (!category) tempErrors.category = "Field is required";
    return tempErrors;
  };


  const handleChangeSubCategory=(event)=>{
    const {
        target: { value },
      } = event;
      
  // Split the string by commas and trim any leading/trailing whitespace from each value
  const valueArray = value.split(',').map((item) => item.trim());

  // Update the state with the array
  setsubcategory(valueArray);
  }

  const updateTicket = async (dataToUpdate) => {
    try {
      const token = localStorage.getItem('token');
  
      const response = await axios.post(
        'http://localhost:8028/api/v1/query/createCategory', // Replace with your API endpoint
        dataToUpdate,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json', // Adjust content type if necessary
          },
        }
      );
  
      console.log('Data updated:', response.data);
      return response.data; // Return data if needed
    } catch (error) {
      console.error('Error updating data:', error);
      throw error; // Handle or rethrow the error as needed
    }
  };


  const submit=()=>{
   
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      // Form is valid, proceed with form submission
      console.log("Form submitted");
    }
    const dataToUpdate={
        category:category,
        subCategory:subcategory,
        mailList:[
            {
                LEVEL1:level1,
                emailString:level1
            },
            {
                LEVEL2:level2,
                emailString:level2
            },
            {
                LEVEL3:level3,
                emailString:level3
            }
        ],
       
    }
    updateTicket(dataToUpdate)
    console.log(level1,level2,level3,category,subcategory)
    setlevel1([])
    setlevel2([])
    setlevel3([])
    setcategory('')
    setsubcategory('')
  }

  

  return (
    <div>

    <Box p={2} maxWidth={400} >
    <Grid container mb={5} spacing={3} direction="column">
        <Grid item>
        <Typography variant="h5" >
        Add a ticket category
        </Typography>
        </Grid>
      <Grid  item>
        <Typography variant="body1" gutterBottom>
          Add a Category
        </Typography>
        <TextField  error={!!errors.textFieldValue}
        helperText={errors.textFieldValue} InputProps={{sx:{height:50}}} required value={category} onChange={handleChangeCategory} variant="outlined" fullWidth />
      </Grid>
      <Grid  item>
        <Typography variant="body1" gutterBottom>
        Add a Sub-Category
        </Typography>
        <TextField  InputProps={{sx:{height:50}}} required value={subcategory} onChange={handleChangeSubCategory} variant="outlined" fullWidth />
      </Grid>
      <Grid item>
      <Typography variant="h5" >
      Add Levels and Roles
        </Typography>
        </Grid>
      <Grid item>
      <Typography variant="body1" gutterBottom>
        Add a Level 1 User
        </Typography>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={level1}
          sx={{width:400,height:50}}
          required
          onChange={handleChangeLevel1}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{width:400,height:30}}
             // style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item>
      <Typography variant="body1" gutterBottom>
      Add a Level 2 User
      </Typography>
      <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={level2}
          sx={{width:400,height:50}}
         required
          onChange={handleChangeLevel2}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{width:400,height:30}}
             // style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      <Grid item>
      <Typography variant="body1" gutterBottom>
      Add a Level 3 User
      </Typography>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={level3}
          sx={{width:400,height:50}}
           required
          onChange={handleChangeLevel3}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {names.map((name) => (
            <MenuItem
              key={name}
              value={name}
              sx={{width:400,height:30}}
             // style={getStyles(name, personName, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </Grid>
      
    </Grid>
    <Grid container direction="row">
          <Button variant="contained" sx={{mr:3,backgroundColor:'#778899','&:hover': {
          backgroundColor: '#778899', // Keep the background color same as default
        },}} >Cancel</Button> 
          <Button variant="contained" onClick={submit}>Submit</Button>
      </Grid>
  </Box>
  </div>
  )
}

export default ConfigureTicket
